(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("searchSelector", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["searchSelector"] = factory(require("vue"));
	else
		root["searchSelector"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_43__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition